import { TEST_IDS } from '@va/constants';
import dayjs from 'dayjs';
import { useDateInputContext } from './DateInputContext';
import { PickerButton } from './PickerButton';
import { DateInputView } from './types';

export const Month = () => {
  const { setView, setMonth, isDateInRange } = useDateInputContext();

  return (
    <div className='grid grid-cols-2 gap-1' data-testid={TEST_IDS.generic.datePicker.monthsPanel}>
      {dayjs.monthsShort().map((month, index) => {
        const date = dayjs().month(index).day(1);
        const isDisabled = !isDateInRange(date, 'month');

        return (
          <PickerButton
            onClick={() => {
              setMonth(index);
              setView(DateInputView.Day);
            }}
            className='!font-medium'
            data-testid={TEST_IDS.generic.buttons.select}
            disabled={isDisabled}
          >
            {month}
          </PickerButton>
        );
      })}
    </div>
  );
};
